angular.module('SpidApp')

.factory('InventorySyncService', ['$http', 'SyncConfig', 'Chunker', '$q', function ($http, SyncConfig, Chunker, $q) {
  var nodeUrl = SyncConfig.Node.getURLFor('/inventories')
  var nodeAuthorization = SyncConfig.Node.Authorization
  
  var distantUrl = SyncConfig.Distant.getURLFor('/inventories')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var InventorySyncService = {
    Node: {
      getAllUnsync: function (lastSyncIsoDate) {
        if (!lastSyncIsoDate) {
          throw 'InventorySyncService::Node::getAllUnsync() - Missing parameters'
        }

        var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        }).then(function (datas) {
          var filteredDatas = _.filter(datas, function (data) {
            return moment(data.updated_at).isAfter(moment(lastSyncIsoDate), 'second') // TODO
          })
          return filteredDatas
        })
      }
    },
    Distant: {
      pushAll: function (datas) {
          var chunked = Chunker.inConstantSizeChunks(datas, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
              var data = chunked[i]
              var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
              pool.push($http(req))
          }

          return p.then(function () {
              return $q.all(pool)
          }).then(function () {
              return {generic: 'OK'}
          })
      }
    }
  }

  return InventorySyncService
}])